import axios from "axios";
import API_URL from "./index.js";

export const axiosSchool= axios.create({
  baseURL: API_URL.superStudent,
  headers: {
    'Accept': 'application/json',
  },
});

export const axiosEvent= axios.create({
  baseURL: API_URL.urlEvent,
  headers: {
    'Authorization': `Bearer eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ`,
  },
});